import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter} from "react-router-dom";
import _ from 'lodash';
import queryString from 'query-string';
import {clearUploadErrors} from 'store/state/cashflows';
import { withStyles } from "@material-ui/core/styles";
import {
  IconButton, Dialog, DialogTitle, DialogContent,
  Button,
  CircularProgress,
  Fade,
  DialogActions,
  Grid,
} from "@material-ui/core";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import FileUpload from 'components/Files/Upload';
import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import DatePicker from "material-ui-pickers/DatePicker";
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import MaterialDatePicker from "material-ui-pickers/DatePicker";

const Spacer = styled.div`
  flex-grow:1;
`
const Description = styled.div`
  color: rgba(0, 0, 0, 0.537);
  padding-bottom:20px;
`;
const ValidationGrid = styled(Grid)`
  && {
    height:264px;
  }
`
const ValidationComment = styled.div`
  color: rgba(0, 0, 0, 0.537);
`
const StyledCancelButton = styled(PrimaryButton)`
  &&& {
    margin-right:12px;
  }
`
export const VerticalDivider = styled.div`
  height:100%;
  border-right: 1px solid #cccccc;
`;
const Error = styled.div`
  color:#ff0000;
  font-size:17px;
  padding-left:8px;
`

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
  `

  const styles = theme => ({
    customPaperWidthMd: {
      maxWidth:'780px',
      minWidth: '750px'
    }
  });

class SreoUploadModal extends Component {    
    state = {
        companyId: '',
        asOfDate:'',
        templateError: ''
    }
  close = () => {    
    this.props.clearUploadErrors();
    this.props.onClose();
    this.setState({companyId: '', asOfDate: '', templateError: ''});
  }

  componentDidUpdate(prevProps) {
    if(prevProps.selectedCompany !== this.props.selectedCompany) {
      this.setState({companyId: this.props.selectedCompany});
    }
  }

  handleTemplateRequest = () => {
    let state = this.state;
    this.props.onTemplateRequest(state.companyId, state.asOfDate);
  }

  render() {            
    const { classes, isOpen, onUpload,errorMessage, showSpinner, companies, error } = this.props;                 
    return (
      <Fragment>
        <Dialog 
          classes={
            {
              paperWidthMd: classes.customPaperWidthMd
            }
          } 
          open={isOpen} 
          onClose={this.close} 
          maxWidth="md">
          <Grid
            container            
            alignItems="center"
            justify="space-between"
          >
            <DialogTitle>Upload SREO data</DialogTitle>
          </Grid>          
          <DialogContent>            
            {!showSpinner && <Grid container spacing={8} justify="space-between">
              <Grid container item xs={5}>
                <Grid item xs={12}>
                    <Description >Choose a company to upload data for:</Description>
                    <Select
                            placeholder="Select a company"
                            value={this.state.companyId}
                            variant="filled"
                            style={{minWidth: "256px"}}
                            onChange={(event) => {
                                let state = this.state;
                                state.companyId = event.target.value;
                                this.setState(state);
                            }}
                            >
                        <MenuItem value="" disabled>Select a company</MenuItem>
                        {companies && companies.map((company => {
                            return (
                                <MenuItem value={company.id}>{company.name}</MenuItem>
                            ) 
                        }))}
                    </Select>
                </Grid>
                <Grid item xs={12} style={{paddingTop: "50px"}}>
                    <MaterialDatePicker label="As Of Date" fieldName="calculationDate"
                        style={{width:"100%"}}
                        name="startDate"
                        format="MM/DD/YYYY"
                        onChange={value => {
                            let state = this.state; 
                            state.asOfDate = value;
                            this.setState(state);
                        }}
                        value={this.state.asOfDate}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Description >Click to download the SREO template</Description>
                    <SecondaryButton onClick={() => {this.props.onTemplateRequest(this.state.companyId, this.state.asOfDate)}} 
                        style={{textTransform: 'capitalize'}}>
                        SREO Template
                    </SecondaryButton>
                </Grid>
              </Grid>              
              <Grid item>
                <VerticalDivider/> 
              </Grid>
              <Grid item container xs={5} >
                <Description>Choose an edited template to upload:</Description>
                <FileUpload onDrop={(file) => { this.props.onUpload(file, this.state.companyId, this.state.asOfDate)}}/>
              </Grid>
              {error}
            </Grid>}
            {showSpinner && (
            <ValidationGrid direction="column" container justify="center" alignItems="center" spacing={16}>
                <Grid item>
                  <CircularProgress size={120} thickness={1}/>
                </Grid>
                <Grid item>                  
                  <ValidationComment>Validating file..</ValidationComment>              
                </Grid>
            </ValidationGrid>
            )}
          </DialogContent>
          <StyledDialogActions>            
            <Fade in={!!errorMessage}>
              <Error>{errorMessage}</Error>
            </Fade>
            <Spacer></Spacer>
            <Fragment>
              <StyledCancelButton onClick={this.close}>Cancel</StyledCancelButton>              
            </Fragment>
          </StyledDialogActions>
        </Dialog>
      </Fragment>
    )
  }
}
const mapStateToProps = (state, props) => {
};

export default compose(
  withRouter,
  connect(mapStateToProps, {clearUploadErrors}),
  withStyles(styles) 
)(SreoUploadModal);
